export default __webpack_public_path__ + "static/kokkaigijidomae-20090213-DSC03295-resize-w2000-4ea65ce4f7ade0d61d4a78613bdb6db4.jpg";